import { Box, Button, SxProps, Theme } from "@mui/material";
import { combineSx, createStyleSheet } from "../utils/styles";

import { theme } from "../../theme";

export interface TabViewEntry {
  content: string;
  selected: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const TabView = (props: {
  entries: TabViewEntry[];
  sx?: SxProps<Theme>;
  disabled?: boolean;
  postTabComponent?: React.ReactNode;
}) => {
  const { entries, sx, disabled, postTabComponent } = props;
  return (
    <Box sx={combineSx(styles.tabButtonContainer, sx)}>
      {entries.map((entry) => (
        <Button
          key={entry.content}
          variant="text"
          disabled={disabled}
          sx={{
            ...styles.tabButton,
            borderBottom: (theme) =>
              entry.selected && !disabled
                ? `2px solid ${theme.palette.primary.main}`
                : "2px solid transparent",
          }}
          onClick={(e) => {
            e.preventDefault();
            entry.onClick?.(e);
          }}
        >
          {entry.content}
        </Button>
      ))}
      {postTabComponent}
    </Box>
  );
};

const styles = createStyleSheet({
  tabButtonContainer: {
    display: "flex",
    flexDirection: "row",
    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
  },
  tabButton: {
    borderRadius: 0,
    minWidth: 98,
    [theme.breakpoints.down("desktop")]: {
      minWidth: 76,
    },
    px: 2,
  },
});

export default TabView;
